import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '@core/index';
import LoginForm from '../components/LoginForm';
import SecureAccessBadge from '../components/SecureAccessBadge';
import GoogleAuth from '../components/GoogleAuth';
import AppLogo from '@shared/components/branding/AppLogo';

const LoginPage = () => {
  const authenticated = isAuthenticated();

  if (authenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {/* Handle OAuth callback if present */}
      <GoogleAuth />

      <AppLogo size="large" variant="login" />
      <LoginForm />
      <SecureAccessBadge />
    </>
  );
};

export default LoginPage;
